import { OpcaoSelect, SelectField } from '@/global/components/SelectField'
import { cn } from '@/lib/utils'

type Props<T> = {
    label: string
    options: OpcaoSelect<T>[] | undefined
    value: T
    onValueChange: (valor: T) => void
    className?: string
    'data-testid'?: string
}

/**
 * Select das linhas do painel de filtros — sempre `outlined`/`small` e sem
 * linha auxiliar, para que os campos da linha fiquem na mesma altura.
 */
export default function FilterPanelSelect<T>({
    className,
    ...props
}: Props<T>) {
    return (
        <SelectField
            {...props}
            variant="outlined"
            size="small"
            className={cn(
                // Sem rótulo o gatilho encolhe (36px). Na linha de filtros ele
                // fica ao lado dos campos com rótulo, que têm 48px.
                !props.label && '[&_[data-slot=select-trigger]]:h-12',
                className,
            )}
        />
    )
}
